import { api, makeApiRequest } from 'api/_init'
import { formatDateYYYYMMDD } from 'utils/helpers'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapRuntimeBudget, mapRuntimeBudgetUpdateResult, mapRuntimeBudgetError } from './mappers'

// POST /runtime_budget takes budget/start_date/end_date/dry_run as query-
// string args (reqparse.RequestParser, no JSON body) — same wire convention
// v3's postBudgetAndRuntime/getDailyBudgetPreview used, just one shared
// endpoint+verb now instead of two, differentiated by dry_run.
function buildRuntimeBudgetQuery(eventId, { budget, startDate, endDate }, dryRun) {
  let url = `/events/${eventId}/runtime_budget?budget=${budget}&end_date=${formatDateYYYYMMDD(endDate)}&dry_run=${dryRun}`
  if (startDate) {
    url += `&start_date=${formatDateYYYYMMDD(startDate)}`
  }
  return url
}

const runtimeBudgetApi = {
  fetchAsync: async (eventId) => {
    const response = await makeApiRequest(api, 'get', `/events/${eventId}/runtime_budget`)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapRuntimeBudget(data), status }
    }
    return { error: mapRuntimeBudgetError(error, status), status }
  },

  // dry_run=true — computes the proposed new_daily_budget without applying it
  // or dispatching anything to the Integration Worker.
  previewAsync: async (eventId, { budget, startDate, endDate }) => {
    const url = buildRuntimeBudgetQuery(eventId, { budget, startDate, endDate }, true)
    const response = await makeApiRequest(api, 'post', url)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapRuntimeBudgetUpdateResult(data), status }
    }
    return { error: mapRuntimeBudgetError(error, status), status }
  },

  // dry_run=false — applies the change and dispatches to the IW; response's
  // taskDetails carries the poll handle (task_id/status). A PAUSED Google
  // campaign is reactivated as a side effect of a successful update — see
  // schemas.js's GOOGLE_REACTIVATES_PAUSED_CAMPAIGN_ON_BUDGET_UPDATE.
  updateAsync: async (eventId, { budget, startDate, endDate }) => {
    const url = buildRuntimeBudgetQuery(eventId, { budget, startDate, endDate }, false)
    const response = await makeApiRequest(api, 'post', url)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapRuntimeBudgetUpdateResult(data), status }
    }
    return { error: mapRuntimeBudgetError(error, status), status }
  },
}

export default runtimeBudgetApi
